module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC42OSAzNS45OSI+PHRpdGxlPmljb24tZmFjZWJvb2s8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJJY29uc19ncmFwaGljcyIgZGF0YS1uYW1lPSJJY29ucy9ncmFwaGljcyI+PHBhdGggaWQ9ImYiIGQ9Ik0xMi4xMywzNlYxOS41N2g1LjUxbC44My02LjM5SDEyLjEzVjkuMDljMC0xLjg1LjUyLTMuMTEsMy4xNy0zLjExaDMuMzlWLjI1QTQ1LjA5LDQ1LjA5LDAsMCwwLDEzLjc1LDBDOC44NywwLDUuNTIsMyw1LjUyLDguNDZ2NC43MkgwdjYuMzlINS41MlYzNloiIHN0eWxlPSJmaWxsOiM5MTU4ZGIiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-facebook.svg
// module id = iJdc
// module chunks = 1